import { useMemo } from "react";
import useSWR from "swr";

import { type ApiError } from "../ApiError";
import * as fetcher from "../fetcher";
import { opportunitiesSearchFiltersFromString } from "./search";
import { type OpportunitiesSearchFilters } from "./types";

export const ProjectFilterDefault: OpportunitiesSearchFilters = {
  term: undefined,
  amount: undefined,
  opportunityType: [],
  classification: [],
  createdDate: [],
  updatedDate: [],
  status: [],
  department: [],
  businessUnit: [],
  customerType: [],
  services: [],
  followUpConsentFilter: undefined,
  promotionalConsentFilter: undefined,
  teamFilter: undefined,
  coworkerFilter: [],
  tags: [],
  nbaTypes: [],
  orderStatus: [],
  customerLocales: [],
  orderMethod: [],
  isWidgetSearch: false,
  isNoActionPlanned: false,
  isColdProject: false,
  followupAssignee: undefined,
  projectIds: undefined,
  installationType: [],
  installationDate: [],
  stageFilter: [],
  expectedPurchaseDateFilter: [],
  budgetFilter: undefined,
};

interface SavedFiltersResponse {
  salesLeadFilter: string;
}

export function useFilters() {
  const { data, isValidating } = useSWR<SavedFiltersResponse, ApiError>(
    `/coworkers/filters`,
    (url) => fetcher.core.get(url),
    {
      revalidateOnFocus: false,
    }
  );

  const savedFilters = useMemo(() => {
    if (!isValidating && data?.salesLeadFilter) {
      return opportunitiesSearchFiltersFromString(data?.salesLeadFilter ?? "");
    }

    return null;
  }, [data, isValidating]);

  return { isLoaded: !isValidating, savedFilters };
}
